/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Case } from '../../models/case';
import { TodoCompleted } from '../../models/todo-completed';

export interface SetCaseTodoCompleted$Params {

/**
 * case id of a resource
 */
  case_id: string;

/**
 * Todo id of a resource
 */
  todo_id: string;
      body: TodoCompleted
}

export function setCaseTodoCompleted(http: HttpClient, rootUrl: string, params: SetCaseTodoCompleted$Params, context?: HttpContext): Observable<StrictHttpResponse<Case>> {
  const rb = new RequestBuilder(rootUrl, setCaseTodoCompleted.PATH, 'patch');
  if (params) {
    rb.path('case_id', params.case_id, {"style":"simple","explode":false});
    rb.path('todo_id', params.todo_id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Case>;
    })
  );
}

setCaseTodoCompleted.PATH = '/api/v1/cases/{case_id}/todos/{todo_id}/set_completed';
